
















































import Engine, { SpaceMap as SpaceMapData } from "@gaia-project/engine";
import { CubeCoordinates } from "hexagrid";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { MapMode, MapModeType } from "../data/actions";
import { hexCenter } from "../graphics/hex";
import FactionWheel from "./FactionWheel.vue";
import Sector from "./Sector.vue";
import Definitions from "./definitions/Definitions.vue";

@Component<SpaceMap>({
  components: {
    FactionWheel,
    Definitions,
    Sector,
  },
})
export default class SpaceMap extends Vue {
  hexCenter(hex: CubeCoordinates) {
    return hexCenter(hex);
  }

  get highlightedSectors(): CubeCoordinates[] {
    return this.$store.state.context.highlighted.sectors;
  }

  get sectors(): CubeCoordinates[] {
    return this.map.configuration().centers;
  }

  rotation(center: CubeCoordinates) {
    return this.$store.state.context.rotation.get(`${center.q}x${center.r}`) || 0;
  }

  get engine(): Engine {
    return this.$store.state.data;
  }

  get showCharts(): boolean {
    return !this.engine.players.some((p) => !p.faction);
  }

  get map(): SpaceMapData {
    return this.engine.map;
  }

  get right() {
    return (this.sectors || []).length > 7 ? 33.5 : 26;
  }

  get mapModes(): MapMode[] {
    return this.$store.getters.mapModes;
  }

  get colorLegend(): { class: string; text: string }[] {
    if (this.mapModes.find((m) => m.type === MapModeType.leech || m.type == MapModeType.federations)) {
      return [...Array(5).keys()].map((i) => ({ class: `power${i + 1}`, text: String(i + 1) }));
    }
    return [];
  }
}
